// WHICH FEW OF MANY SHE IS OFFERED — the Ask Lala page's suggestion chips, and any other place this
// house shows a handful drawn from a pool.
//
// **PULLED OUT OF `App.tsx` BY THE BROADCAST ROUND (2026-08-11) FOR THE REASON EVERY EXTRACTION HERE
// HAS HAD, AND THE MOVE IMPROVED IT.** It was six lines inside an 12,000-line TSX file, so no `.mjs`
// gate could load it — and its whole behaviour turned on a bare `Math.random()`, which is the one
// thing a fixture can never pin down from the outside. **`rng` IS A PARAMETER NOW** (the shape
// `seal-run.ts` gives `now` and `locked-door.ts` gives the window), so a gate DRIVES it with a
// sequence it chose and reads back exactly which items were taken.
//
// It imports NOTHING, which is the entry requirement for this folder.

/**
 * `count` items drawn from `pool` without replacement, in the order they were drawn.
 *
 * **IT NEVER MUTATES THE POOL AND IT NEVER OVER-DRAWS.** The copy is what keeps a caller's catalog
 * intact — `ASK_LALA_CHIP_POOL` is a module-level constant and a splice on it would empty the
 * suggestions permanently after a few page opens — and the `while` stops at whichever runs out
 * first, so asking for five from a pool of three answers three rather than three and two holes.
 *
 * A `count` of zero or less draws nothing, which is the honest reading of it and not an error.
 */
export function pickSome<T>(pool: T[], count: number, rng: () => number = Math.random): T[] {
  const copy = pool.slice();
  const out: T[] = [];
  while (copy.length && out.length < count) out.push(copy.splice(Math.floor(rng() * copy.length), 1)[0]);
  return out;
}
